import { CtrlCollection } from "@yuigoto/ctrl";
import { SanitizeToDigits } from "@yuigoto/validators/dist/utils/Utils";
import { ControlRenderer } from "components/renderers/ControlRenderer";
import React, { Component } from "react";
import { connect } from "react-redux";
import { UiActions } from "state/actions/UiActions";
import { PersonActions } from "state/actions/user/PersonActions";
import Styles from "views/pages/DadosPessoais.module.scss";
import { PersonInfoControl } from "../../controls/PersonInfoControl";

class InfoChange extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validationMessage: ""
    }
    this.collection = new CtrlCollection();
    let { person } = this.props;


    for (let i = 0; i < PersonInfoControl.length; i++) {
      let name,
        alias;

      if (Array.isArray(PersonInfoControl[i])) {
        let tempCollection = new CtrlCollection();

        for (let n = 0; n < PersonInfoControl[i].length; n++) {
          name = PersonInfoControl[i][n].name;
          alias = PersonInfoControl[i][n].alias;

          if (name === "firstName" || alias === "first_name") {
            PersonInfoControl[i][n].value = person["name"];
          } else if (/cpf/gi.test(name) || /cpf/gi.test(alias)) {
            let val = person[name] || person[alias];
            if (typeof val === "number") val = val.toString();

            if (val.length < 11) {
              while (val.length < 11) {
                val = "0" + val;
              }
            }

            PersonInfoControl[i][n].value = val;
          } else if (person[name] || person[alias]) {
            PersonInfoControl[i][n].value = person[name] || person[alias];
          }

          tempCollection.add(PersonInfoControl[i][n]);
        }
        this.collection.add(tempCollection);
      } else {
        let name = PersonInfoControl[i].name,
          alias = PersonInfoControl[i].alias;

        if (name === "firstName" || alias === "first_name") {
          PersonInfoControl[i].value = person["name"];
        } else if (/cpf/gi.test(name) || /cpf/gi.test(alias)) {
          let val = person[name] || person[alias];

          if (val !== null && typeof val !== "undefined") {
            if (typeof val === "number") val = val.toString();

            if (val.length < 11) {
              while (val.length < 11) {
                val = "0" + val;
              }
            }
          }

          PersonInfoControl[i].value = val;
        } else {
          if (
            person[name] !== null && person[name] !== undefined
            || person[alias] !== null && person[alias] !== undefined
          ) {
            PersonInfoControl[i].value = person[name] || person[alias];
          }
        }

        // if(PersonInfoControl[i].name === "newsletterOptIn" ||
        //    PersonInfoControl[i].alias === "newsletter"){
        //     PersonInfoControl[i].onChange = this.updateOnToggle;
        // }

        this.collection.add(PersonInfoControl[i]);
      }
    }

    this.showMessage = this.showMessage.bind(this);
  }

  // updateOnToggle = () =>{
  //   this.submitChange
  // }

  submitChange = (event) => {
    event.preventDefault();

    if (this.collection.validate()) {
      let personData = this.collection.toObject(true),
        birth = new Date(
          personData.birthday.split("/").reverse().join("-") + "T00:00:00"
        );

      personData.cpf = SanitizeToDigits(personData.cpf);
      personData.birthday = birth.toLocaleDateString(`pt-BR`);

      this.props.personUpdate(
        Object.assign(
          {},
          personData
        ),
        (response) => {
          let {
            result,
            statusCode
          } = response;

          if (statusCode === 200) {
            //this.props.successAlert(result.message);
          } else {
            this.props.errorAlert(
              (result && result.message)
                ? result.message
                : null
            );
          }
        }
      );
    } else {
      this.forceUpdate();
    }
  };

  showMessage() {
    if (this.state.message) {
      return (<p>{this.state.message}</p>)
    }
  }

  render() {
    return (
      <div className={"level-2 mb-2"}>
        <div className={"gb-contentblock p-3 p-lg-4"}>
          <form onSubmit={this.submitChange}>
          <p><small>* Campo Obrigatório</small></p>

            {ControlRenderer.renderCollection(this.collection)}
            {this.showMessage()}
            <div className={Styles['info__buttons_InfoChange']}>
              <button id={"submitButton"} className={"btn btn-light-pink btn-md"}>
                Alterar Dados
              </button>
            </div>
          </form>

        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    person: state.person.data.person,
    token: state.token.data,
    partnerInfo: state.partnerInfo.data,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    personUpdate: (person, callback) => {
      dispatch(PersonActions.updatePerson(person, callback))
    }
    , successAlert: (message) => {
      dispatch(UiActions.publishSuccessAlert(message))
    }
    , errorAlert: (message) => {
      dispatch(UiActions.publishErrorAlert(message))
    }
  }
}

InfoChange = connect(mapStateToProps, mapDispatchToProps)(InfoChange);

export { InfoChange };

